<!-- Ported from the Polaris kit: src/components/ui/button/Button.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { Primitive } from 'reka-ui';
import { cn } from '../../lib/utils';
import { buttonVariants } from '.';

const props = defineProps({
  variant: { type: null, required: false },
  size: { type: null, required: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false, default: 'button' },
  // Polaris patch: pending state. Disables the button, announces it as busy and shows a spinner.
  loading: { type: Boolean, required: false },
});

// Polaris patch: attrs are bound by hand so `loading` can force `disabled` even if the parent passes disabled=false.
defineOptions({ inheritAttrs: false });
</script>

<template>
  <Primitive
    data-slot="button"
    :data-variant="variant"
    :data-size="size"
    :as="as"
    :as-child="asChild"
    v-bind="$attrs"
    :disabled="
      loading ||
      ($attrs.disabled !== undefined && $attrs.disabled !== false) ||
      undefined
    "
    :aria-busy="loading || undefined"
    :class="cn(buttonVariants({ variant, size }), props.class)"
  >
    <span
      v-if="loading"
      class="size-4 shrink-0 animate-spin rounded-full border-2 border-current border-r-transparent p-0"
      aria-hidden="true"
    />
    <slot />
  </Primitive>
</template>
